import { render, staticRenderFns } from "./AccordionDefault.vue?vue&type=template&id=bf46e706&"
import script from "./AccordionDefault.vue?vue&type=script&lang=js&"
export * from "./AccordionDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports